import type { PetitionDraft } from '#src/app/shared/api/petitionDraft';
import { useClearedMultipleQueryParamsValues, useClearedQueryParamValue } from '#src/app/shared/hooks/location';
import { getLoginOrJoinMethod, LOGIN_OR_JOIN_METHOD_QUERY_KEY } from '#src/app/shared/utils/loginOrJoin';

export function useInitialDraft(draft: PetitionDraft): PetitionDraft {
	const loginOrJoinMethodShortcode = useClearedQueryParamValue(LOGIN_OR_JOIN_METHOD_QUERY_KEY) ?? '';
	const loginOrJoinMethod = getLoginOrJoinMethod(loginOrJoinMethodShortcode) ?? undefined;

	const getUserState = () => {
		return { ...draft.metadata?.user, loginOrJoinMethod: draft.metadata?.user?.loginOrJoinMethod ?? loginOrJoinMethod };
	};

	const [issueParam, personalStoryParam] = useClearedMultipleQueryParamsValues(['issue', 'personal-story']);

	// Chat App and Social Entry support pre-filling issue and personal story via query params.
	// Issue is always required; personal story is optional.
	const hasPrefilledParams = !!issueParam;

	if (hasPrefilledParams) {
		return {
			...draft,
			input: {
				issuePrompt: issueParam,
				personalStory: personalStoryParam ?? undefined,
			},
			metadata: { ...draft.metadata, user: getUserState() },
		};
	}

	return {
		...draft,
		metadata: { ...draft.metadata, user: getUserState() },
	};
}
